import BaseCoinValueContainer from 'Engine/containers/ui/BaseCoinValueContainer';
import { shadowText } from 'Engine/utils/fontStyles';

export default class BetSelectorContainer extends BaseCoinValueContainer {
  init() {
    super.init();
    this.titleText.style = {...this.titleText.style, ...shadowText}
  }
}
